import { useEffect } from "react";
import { useState } from "react";
import Nav from "./Nav";
import NavMobile from "./NavMobile";
import Social from "./social";
import gkLogo from "../assets/img/gkLogo.png"
import Logo from "../assets/img/logo.svg"

function Header() {
  const [bg, setBg] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      return window.scrollY > 50 ? setBg(true) : setBg(false);
    });
  }, []);
  return (
    <header
      className={`${
        bg ? "bg-tertiary h-20" : "h-24"
      }flex items-center fixed top-0 w-full text-whtie z-10 transition-all duration-300 `}
    >
      <div className="container mx-auto h-full flex items-center justify-between">
        {/* LOGO  */}
        <a href="#">
           <img src={gkLogo} width={60} alt="" /> 
        </a>
        {/* nav  */}
        <div className="hidden lg:block">
            <Nav />
        </div>
        {/* social  */}
        <div className="hidden lg:block">
            <Social />
        </div>
        {/* nav  mobile  */}
        <div className="lg:hidden">
            <NavMobile />
        </div>
      </div>
    </header>
  );
}

export default Header;
